import React from 'react';
import {
  Bell,
  List,
  Pencil,
  Beaker,
  Robot,
  GraphUp,
  BoxArrowRight,
  Shield,
  Bug,
  CreditCard,
  Images,
  Gear,
  Envelope,
  ListCheck,
  FileEarmarkText,
  ExclamationTriangleFill,
  Speedometer2,
  HeartPulse,
  Briefcase,
  Globe,
  BarChartLine,
  Activity,
  ClockHistory,
} from 'react-bootstrap-icons';

const NAV_ICON_COMPONENTS = {
  bell: Bell,
  list: List,
  pencil: Pencil,
  beaker: Beaker,
  robot: Robot,
  graphUp: GraphUp,
  creditCard: CreditCard,
  images: Images,
  shield: Shield,
  bug: Bug,
  logout: BoxArrowRight,
  envelope: Envelope,
  gear: Gear,
  checklist: ListCheck,
  journalPage: FileEarmarkText,
  danger: ExclamationTriangleFill,
  performance: Speedometer2,
  overview: Briefcase,
  health: HeartPulse,
  globe: Globe,
  barChart: BarChartLine,
  activity: Activity,
  clockHistory: ClockHistory,
};

/** @param {string} name @param {number} [size] */
export function DashboardNavIcon({ name, size = 16, style, className }) {
  const Icon = NAV_ICON_COMPONENTS[name];
  if (!Icon) return null;
  return <Icon size={size} className={className} style={{ flexShrink: 0, opacity: 0.9, ...style }} />;
}

export function renderDashboardNavIcon(name, size = 14) {
  return <DashboardNavIcon name={name} size={size} />;
}
